import React, { useEffect, useState } from "react";
import ListSchedule from "../listSchedule";
import scheduleService from "../../../services/schedule.service";

const DashboardMhesi = () => {
  const [schedule, setSchedule] = useState([]);
  //เช็กว่ามีกำหนดการ มคอ เปิดรับเอกสารไหม ถ้าเปิดให้ list รายการกำหนดการที่เปิดรับ ถ้าไม่ แสดงข้อความว่าไม่มีเอกสารที่ต้องส่ง
  //get schedule where status = true and type = tqf  ยิงไปที่นี่ http://localhost:5500/api/schedule/tqf
  useEffect(() => {
    (async () => {
      //ดำเนินการตรงนี้
      const scheduleMhesi = await scheduleService
        .getScheduleOpenForSend("mhesi")
        .then((res) => {
          // console.log(res.data);

          return res.data;
        });
      if (scheduleMhesi.length > 0) {
        setSchedule(scheduleMhesi);
      }
    })();
  }, []);

  if (schedule.length <= 0) {
    return <></>;
  }

  return (
    <div className="alert alert-secondary rounded-3 text-dark" role="alert">
      <h3 className="mt-2 bg-white rounded-pill p-2">
        <strong>กำหนดส่ง อชว. | RMUTI</strong>
      </h3>
      <div className="container mt-4">
        <div className="row row-cols-1 row-cols-md-4  g-4 text-end justify-content-center align-items-center">
          {schedule.map((schedule: any) => {
            return (
              <ListSchedule key={schedule.id} type="อชว." schedule={schedule} />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default DashboardMhesi;
